import { getSectionHeadingPath } from '@utils/apiFunctions.js';
import httpClient from '@utils/httpClient.js';

export function updateAppointmentApiCall({
  id,
  isPathDesign,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,

  itemShadow,
  itemShadowColor,
  itemShape,
  itemOpacity,
  itemBorder,
  itemBorderColor,

  buttonText,
  buttonOpacity,
  buttonBackgroundColor,
  buttonTextColor,
  buttonBorder,
  buttonBorderColor,
  buttonShadow,
  buttonShadowColor,
  buttonShape,

  viewType,
  calendlyToken,
  calendlyEmbedUrl,
}) {
  return httpClient.put(getSectionHeadingPath('appointments', isPathDesign, id), {
    id,
    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,

    itemShadow,
    itemShadowColor,
    itemShape,
    itemOpacity,
    itemBorder,
    itemBorderColor,

    buttonText,
    buttonOpacity,
    buttonBackgroundColor,
    buttonTextColor,
    buttonBorder,
    buttonBorderColor,
    buttonShadow,
    buttonShadowColor,
    buttonShape,
    isSectionBackground: sectionIsBackground,
    calendlyAccessToken: calendlyToken,
    calendlyEmbedUrl,
    view: viewType,
  });
}
